module.exports = __webpack_public_path__ + "static/hetong-4faad4aab2ace5bffd4bb4a6f8b026c3.png";